import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import CSVGuide from "@/pages/CSVGuide";

export const Route = createFileRoute("/en/a-complete-guide-to-computer-system-validation")({
  head: () => buildRouteHead("/en/a-complete-guide-to-computer-system-validation"),
  component: CSVGuide,
});

